export default "images/限速提示-限速60.png";